import React, { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import App from "./App";
import { withFusePrefix } from "./utils/withFusePrefix";

const container = document.getElementById("seo-metadata-root");

if (container) {
  hydrateRoot(
    container,
    withFusePrefix(
      <StrictMode>
        <App {...window.__seo_metadata_initial_state__} />
      </StrictMode>,
    ),
  );
}
